module.exports = {"TXTCLI_Currency":{"id":"TXTCLI_Currency","defaultMessage":"Currency","track":"Currency"}}